import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class ShopifyIntegrationServices {
/**
 *
 * @param orgId
 * @return
 */
connectToShopify = async (payload) => {
  const url = `${Constants.CONNECT_TO_SHOPIFY}`;
  const connectToShopify = await Helpers.post({
    url,
    data: payload,
  });
  return connectToShopify;
}

/**
 * @param orgId
 * @param {*} payload
 * @return
 */
getShopifyConnections = async (orgId) => {
  let url = `${Constants.GET_SHOPIFY_CONNECTIONS}`;
  if (orgId) url += `?org_id=${orgId}&`;
  const getShopifyConnections = await Helpers.get({
    url,
  });
  return getShopifyConnections;
}

/**
 *
 * @param {*} payload
 * @returns
 */
deleteShopifyConnection = async (payload) => {
  const url = `${Constants.DELETE_SHOPIFY_CONNECTION}`;
  const deleteShopifyConnection = await Helpers.post({
    url,
    data: payload,
  });
  return deleteShopifyConnection;
}

connectTenantToShopifyLocation = async (payload) => {
  const url = `${Constants.CONNECT_TENANT_TO_SHOPIFY_LOCATION}`;
  const connectTenantToShopifyLocationData = await Helpers.put({
    url,
    data: payload,
  });
  return connectTenantToShopifyLocationData;
}

updateShopifyConfiguration = async (payload) => {
  const url = `${Constants.UPDATE_SHOPIFY_CONFIGURATION}`;
  const updateShopifyConfigurationData = await Helpers.post({
    url,
    data: payload,
  });
  return updateShopifyConfigurationData;
}

/**
 *
 * @param {*} payload
 * @returns
 */
syncShopifyInventory = async (payload) => {
  const url = `${Constants.SYNC_SHOPIFY_INVENTORY}`;
  const syncShopifyInventory = await Helpers.post({
    url,
    data: payload,
  });
  return syncShopifyInventory;
};

/**
 *
 * @param {*} payload
 * @returns
 */
syncShopifyCustomer = async (payload) => {
  const url = `${Constants.SYNC_SHOPIFY_CUSTOMER}`;
  const syncShopifyCustomer = await Helpers.post({
    url,
    data: payload,
  });
  return syncShopifyCustomer;
};

/**
 *
 * @param {*} payload
 * @returns
 */
syncShopifySO = async (payload) => {
  const url = `${Constants.SYNC_SHOPIFY_SO}`;
  const syncShopifySO = await Helpers.post({
    url,
    data: payload,
  });
  return syncShopifySO;
};

/**
 *
 * @param {*} payload
 * @returns
 */
syncShopifyOrders = async (payload) => {
  const url = `${Constants.SYNC_SHOPIFY_ORDERS}`;
  const syncShopifyOrders = await Helpers.post({
    url,
    data: payload,
  });
  return syncShopifyOrders;
};

/**
 *
 * @param {*} payload
 * @return
 */
  cancelShopifyOrder = async (payload) => {
    const cancelShopifyOrder = await Helpers.put({
      url: Constants.CANCEL_SHOPIFY_ORDER,
      data: payload,
    });
    return cancelShopifyOrder;
  }

  /**
 *
 * @param {*} payload
 * @return
 */
  createADHOC = async (payload) => {
    const createADHOC = await Helpers.post({
      url: Constants.CREATE_ADHOC,
      data: payload,
    });
    return createADHOC;
  }
}

export default new ShopifyIntegrationServices();
